<template>
  <div class="content" v-loading="loading">
    <el-table :data="tableData" style="width: 100%;" class="dialog">
      <el-table-column
        prop="number"
        label="设备编号"
        sortable
        align="center"
        fixed="left"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="设备别名"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        label="开关状态"
        prop="lights_status"
        width="150"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <i :class="lightStatusColor[scope.row.lights_status]"></i>
          <span>{{ lightStatus[scope.row.lights_status] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="brightness"
        label="亮度"
        align="center"
        width="130"
      ></el-table-column>
      <el-table-column
        label="在线状态"
        prop="ste"
        width="150"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="当前策略"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.ms==0">
            <span v-if="scope.row.group_stg_id">{{ scope.row.group_stg_name }}<br/>(分组策略)</span>
            <span v-else-if="scope.row.stg_id">{{ scope.row.stg_name }}<br/>(本灯策略)</span>
            <span v-else>暂无策略</span>
          </template>
          <template v-else>
            <span>手动操作</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="控制模式"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.ms==0">
            <span v-if="scope.row.group_stg_id||scope.row.stg_id">自动模式</span>
            <span v-else>暂无</span>
          </template>
          <template v-else>
            <span>手动模式</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
  </div>
</template>
<script>
import lightGroupApi from "@/api/light/lampGroup.js"
export default {
  name: "deviceList",
  props: {
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      steColorType: ["valuegrey", "valuegreen"],
      colorClass: ["grey", "green"],
      msType: ["自动", "手动"],
      lightStatusColor: ["valuegrey", "valueyellow"],
      lightStatus: ["关灯中", "亮灯中"],
      steType: ["离线", "在线"],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        lamp_group: this.groupId //灯组
      },
      cnt_all: 0,
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该分组下的所有路灯
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightGroupApi.getGroupLamps(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
